<p-accordion [ngClass]="to.className" (onOpen)="onOpen($event)">
    <p-accordionTab
        [header]="to.label"
        [cache]="to.lazyLoad != true"
        [selected]="to.selected == true"
        [class.marginBottom]="to.marginBottom === true"
        [class.has-error]="hasError"
    >
        <ng-container *ngIf="to.lazyLoad == true">
            <ng-template pTemplate="content">
                <div>
                    <ng-template
                        #fieldComponent
                        autocomplete="nope"
                    ></ng-template>
                </div>
            </ng-template>
        </ng-container>

        <ng-container *ngIf="!to.lazyLoad">
            <div>
                <ng-template #fieldComponent autocomplete="nope"></ng-template>
            </div>
        </ng-container>
    </p-accordionTab>
</p-accordion>
